/**
 * Image configuration for the application
 */

// Configuration for different image types
export const IMAGE_CONFIG = {
  // Literary group avatar configuration
  LIT_GROUP_AVATAR: {
    defaultUrl: '/justBookStack.png',
    maxSize: 5 * 1024 * 1024, // 5MB
    allowedTypes: ['image/jpeg', 'image/png', 'image/gif'],
    dimensions: {
      width: 300,
      height: 300
    }
  },

  // Book cover configuration
  BOOK_COVER: {
    defaultUrl: '/book_cover_icon.png',
    maxSize: 10 * 1024 * 1024, // 10MB
    allowedTypes: ['image/jpeg', 'image/png', 'image/gif'],
    dimensions: {
      width: 600,
      height: 900
    }
  },

  // Character avatar configuration
  CHARACTER_AVATAR: {
    defaultUrl: '/narrator_1-1-480x490.png',
    maxSize: 5 * 1024 * 1024, // 5MB
    allowedTypes: ['image/jpeg', 'image/png', 'image/gif'],
    dimensions: {
      width: 300,
      height: 300
    }
  },

  // User avatar configuration
  USER_AVATAR: {
    defaultUrl: '/justBookStack.png',
    maxSize: 2 * 1024 * 1024, // 2MB
    allowedTypes: ['image/jpeg', 'image/png', 'image/gif'],
    dimensions: {
      width: 200,
      height: 200
    }
  }
};

// Helper functions for image handling

/**
 * Check if an image file is valid based on configuration
 * @param {File} file - The file to check
 * @param {Object} config - The configuration to check against
 * @returns {Object} - Validation result
 */
export const validateImage = (file, config) => {
  // Check if file exists
  if (!file) {
    return { valid: false, error: 'No file provided' };
  }

  // Check file size
  if (file.size > config.maxSize) {
    return {
      valid: false,
      error: `File size exceeds maximum allowed (${Math.round(config.maxSize / (1024 * 1024))}MB)`
    };
  }

  // Check file type
  if (!config.allowedTypes.includes(file.type)) {
    return {
      valid: false,
      error: `File type not allowed. Allowed types: ${config.allowedTypes.join(', ')}`
    };
  }

  return { valid: true };
};

/**
 * Format file size for display
 * @param {number} bytes - File size in bytes
 * @returns {string} - Formatted file size
 */
export const formatFileSize = (bytes) => {
  if (bytes < 1024) {
    return `${bytes} B`;
  } else if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(2)} KB`;
  } else {
    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
  }
};

export default IMAGE_CONFIG;
